import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const sessionData = this.authService.getSessionData();
    if (sessionData && sessionData.sessid) {
      const clonedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${sessionData.sessid}`
        }
      });
      return next.handle(clonedRequest);
    }
    return next.handle(request);
  }
}
